// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RatingProduct-figure {
  position: relative;
  width: 120px;
  height: 120px;
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #DCE2F0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.RatingProduct-figure img {
  max-width: 100%;
  width: auto;
  height: 75%;
  display: block;
  border-radius: 50%;
}
.RatingProduct-price {
  font-size: var(--font-giant);
}
textarea.RatingProduct-textarea {
  min-height: 120px;
  max-width: 650px;
  resize: none;
}
.RatingProduct-textarea::placeholder {
  color: #979AA3;
}
.disclaimer-error {
  max-width: 650px;
}
.container-checkbox-itens {
  display: flex;
}
.modal-rating-container {
  width: 780px !important;
  height: 577px !important;
}
@media only screen and (max-width: 768px) {
  .modal-rating-container {
    width: 400px !important;
    height: auto !important;
    zoom: 1 !important;
  }
}
.ant-modal-body::-webkit-scrollbar {
  width: 12px;
  height: 272px;
}
.ant-modal-body::-webkit-scrollbar-track {
  background: #D9D9D9;
  border-radius: 50px 0px 0px 0px;
}
.ant-modal-body::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-radius: 50px 0px 0px 0px;
  opacity: 0;
}
.modal-rating-body {
  max-height: 529px;
  min-height: 529px;
  overflow-y: auto;
  margin-top: 25px;
  margin-left: 40px;
  overflow-x: hidden;
}
@media only screen and (max-width: 768px) {
  .modal-rating-body {
    margin-left: 0;
  }
  .rate-container {
    display: flex;
    flex-direction: column;
  }
}
.title-container {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 650px;
  height: 30px;
  font-size: var(--font-medium);
  margin-top: 20px;
  margin-left: 40px;
  border-bottom: 1px solid #DCE2F0;
}
@media only screen and (max-width: 768px) {
  .title-container {
    flex-direction: row;
    align-items: flex-start;
    margin-left: 0;
    width: calc(100% - 20px);
  }
  .rate-button-form {
    width: 100%;
  }
}
.title-text {
  margin-left: 10px;
  font-size: var(--font-medium);
  font-weight: bold;
  color: #010001;
}
.title-icon {
  font-size: var(--font-medium);
  color: #010001;
}
.close-icon {
  font-size: var(--font-medium);
}
.product-info {
  padding-left: 35px !important;
  padding-top: 15px !important;
}
.checkbox-container {
  display: flex;
  justify-content: center;
}
.checkbox-item {
  margin-right: 16px;
  display: flex;
  align-items: center;
}
.margin-x-extra-small {
  margin: 0 8px;
}
.margin-y-small {
  margin: 8px 0;
}
.w-100 {
  width: 100%;
}
.custom-divider {
  border-bottom: 1px solid #dce2f0;
  height: 20px;
  width: 650px;
  margin-bottom: 20px;
}
.mr-small {
  margin-right: 15px;
}
.checkbox-text {
  font-size: 14px !important;
  color: var(--color-neutral-dark) !important;
  font-weight: bold !important;
}
.rate-product-txt {
  margin-right: 10px;
  font-size: 16px !important;
}
.rate-container {
  margin-bottom: -15px;
}
@media screen and (max-width: 768px) {
  .container-checkbox-itens {
    display: flex;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/RatingProducts/RatingProducts.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AAEA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AAAF;AAGA;EACE,4BAAA;AADF;AAIA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;AAFF;AAKA;EACE,cAAA;AAHF;AAMA;EACE,gBAAA;AAJF;AAOA;EACE,aAAA;AALF;AAQA;EACE,uBAAA;EACA,wBAAA;AANF;AAUA;EACE;IACE,uBAAA;IACA,uBAAA;IACA,kBAAA;EARF;AACF;AAWA;EACE,WAAA;EACA,aAAA;AATF;AAYA;EACE,mBAAA;EACA,+BAAA;AAVF;AAaA;EACE,mBAAA;EACA,+BAAA;EACA,UAAA;AAXF;AAcA;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAZF;AAeA;EACE;IACE,cAAA;EAbF;EAgBA;IACE,aAAA;IACA,sBAAA;EAdF;AACF;AAoBA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;AAlBF;AAqBA;EACE;IACE,mBAAA;IACA,uBAAA;IACA,cAAA;IACA,wBAAA;EAnBF;EAsBA;IACE,WAAA;EApBF;AACF;AAuBA;EACE,iBAAA;EACA,6BAAA;EACA,iBAAA;EACA,cAAA;AArBF;AAwBA;EACE,6BAAA;EACA,cAAA;AAtBF;AAyBA;EACE,6BAAA;AAvBF;AA0BA;EACE,6BAAA;EACA,4BAAA;AAxBF;AA2BA;EACE,aAAA;EACA,uBAAA;AAzBF;AA4BA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA1BF;AA8BA;EACE,aAAA;AA5BF;AA+BA;EACE,aAAA;AA7BF;AAgCA;EACE,WAAA;AA9BF;AAiCA;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AA/BF;AAkCA;EACE,kBAAA;AAhCF;AAmCA;EACE,0BAAA;EACA,2CAAA;EACA,4BAAA;AAjCF;AAoCA;EACE,kBAAA;EACA,0BAAA;AAlCF;AAqCA;EACE,oBAAA;AAnCF;AAsCA;EACE;IACE,aAAA;IACA,WAAA;EApCF;AACF","sourcesContent":[".RatingProduct-figure {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  overflow: hidden;\n  border-radius: 50%;\n  border: 1px solid #DCE2F0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.RatingProduct-figure img {\n  max-width: 100%;\n  width: auto;\n  height: 75%;\n  display: block;\n  border-radius: 50%;\n}\n\n.RatingProduct-price {\n  font-size: var(--font-giant);\n}\n\ntextarea.RatingProduct-textarea {\n  min-height: 120px;\n  max-width: 650px;\n  resize: none;\n}\n\n.RatingProduct-textarea::placeholder {\n  color: #979AA3;\n}\n\n.disclaimer-error{\n  max-width: 650px;\n}\n\n.container-checkbox-itens{\n  display: flex;\n}\n\n.modal-rating-container {\n  width: 780px !important;\n  height: 577px !important;\n\n}\n\n@media only screen and (max-width: 768px) {\n  .modal-rating-container {\n    width: 400px !important;\n    height: auto !important;\n    zoom: 1 !important;\n  }\n}\n\n.ant-modal-body::-webkit-scrollbar {\n  width: 12px;\n  height: 272px;\n}\n\n.ant-modal-body::-webkit-scrollbar-track {\n  background: #D9D9D9;\n  border-radius: 50px 0px 0px 0px;\n}\n\n.ant-modal-body::-webkit-scrollbar-thumb {\n  background: #D9D9D9;\n  border-radius: 50px 0px 0px 0px;\n  opacity: 0;\n}\n\n.modal-rating-body {\n  max-height: 529px;\n  min-height: 529px;\n  overflow-y: auto;\n  margin-top: 25px;\n  margin-left: 40px;\n  overflow-x: hidden;\n}\n\n@media only screen and (max-width: 768px) {\n  .modal-rating-body {\n    margin-left: 0;\n  }\n\n  .rate-container {\n    display: flex;\n    flex-direction: column;\n  }\n\n}\n\n.rate-button-form {}\n\n.title-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  width: 650px;\n  height: 30px;\n  font-size: var(--font-medium);\n  margin-top: 20px;\n  margin-left: 40px;\n  border-bottom: 1px solid #DCE2F0;\n}\n\n@media only screen and (max-width: 768px) {\n  .title-container {\n    flex-direction: row;\n    align-items: flex-start;\n    margin-left: 0;\n    width: calc(100% - 20px);\n  }\n\n  .rate-button-form {\n    width: 100%;\n  }\n}\n\n.title-text {\n  margin-left: 10px;\n  font-size: var(--font-medium);\n  font-weight: bold;\n  color: #010001;\n}\n\n.title-icon {\n  font-size: var(--font-medium);\n  color: #010001;\n}\n\n.close-icon {\n  font-size: var(--font-medium);\n}\n\n.product-info {\n  padding-left: 35px !important;\n  padding-top: 15px !important;\n}\n\n.checkbox-container {\n  display: flex;\n  justify-content: center;\n}\n\n.checkbox-item {\n  margin-right: 16px;\n  display: flex;\n  align-items: center;\n\n}\n\n.margin-x-extra-small {\n  margin: 0 8px;\n}\n\n.margin-y-small {\n  margin: 8px 0;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.custom-divider {\n  border-bottom: 1px solid rgb(220, 226, 240);\n  height: 20px;\n  width: 650px;\n  margin-bottom: 20px;\n}\n\n.mr-small {\n  margin-right: 15px;\n}\n\n.checkbox-text {\n  font-size: 14px !important;\n  color: var(--color-neutral-dark) !important;\n  font-weight: bold !important;\n}\n\n.rate-product-txt {\n  margin-right: 10px;\n  font-size: 16px !important;\n}\n\n.rate-container {\n  margin-bottom: -15px;\n}\n\n@media screen and (max-width: 768px) {\n  .container-checkbox-itens{\n    display: flex;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
